(function () {
  'use strict';

  var id = 'scatter-plot',
    scatterPlotMeasures = null;

  // Add onto the wsLrs.cards module...
  angular.module('wsLrs.cards').factory(id + '.Utils', ['CardQueryResource', 'AggregationUtils', '$filter', 'QueryES', 'ChartUtils', '$templateRequest', 'wsColors', '$sanitize', function (CardQueryResource, AggUtils, $filter, QueryES, ChartUtils, $templateRequest, wsColors, $sanitize) {
    var self = {
      fetchData: function fetchData(cardId, cardToPreview) {
        var path = "/scatter-plot/data";
        return CardQueryResource.getWithProgress(path, cardId, {
          sample: 1250
        }, cardToPreview, 'scatter-plot-' + cardId);
      },
      ensureDataSize: function ensureDataSize($scope, data) {
        var POINT_LIMIT = 5000;
        var underLimit = data.length < POINT_LIMIT;
        if (!underLimit) {
          $scope.hasData = false;
          $scope.noDataMsg = "Too many data points to display. Report contains " + data.length + " data points.  Maximum allowed is " + POINT_LIMIT + ".";
        }
        return underLimit;
      },
      getStatementDownloadUrl: function getStatementDownloadUrl(cardId) {
        return QueryES.queryExportUrl(cardId, true, id);
      },
      onHighChartComplete: function onHighChartComplete(chart) {
        //user options where we want to draw the quadrants
        // this is the value of the measure
        var x = chart.userOptions.chart.xQuadrant,
          y = chart.userOptions.chart.yQuadrant;
        if (_.isUndefined(x) || _.isUndefined(y)) {
          return;
        }

        //this is the width scaled to fit the plot box
        var xQuad = Math.max(x - chart.xAxis[0].min, 0) / (chart.xAxis[0].max - chart.xAxis[0].min) * chart.plotBox.width,
          yQuad = Math.max(y - chart.yAxis[0].min, 0) / (chart.yAxis[0].max - chart.yAxis[0].min) * chart.plotBox.height;
        var quadFill1 = wsColors.getRGBA(wsColors.wsBlack, 0.1); // Gray
        var quadFill2 = wsColors.getRGBA(wsColors.wsWhite, 1); // White
        var quadFill3 = wsColors.getRGBA(wsColors.wsGreen, 0.5); // Green

        // "B" quad
        chart.renderer.rect(chart.plotBox.x, chart.plotBox.y, xQuad, chart.plotBox.height - yQuad, 1).attr({
          fill: quadFill1,
          zIndex: 0
        }).add();

        // "A" quad
        chart.renderer.rect(chart.plotBox.x + xQuad, chart.plotBox.y, chart.plotBox.width - xQuad, chart.plotBox.height - yQuad, 1).attr({
          fill: quadFill2,
          zIndex: 0
        }).add();

        // "A+" quad
        chart.renderer.rect(chart.plotBox.x + xQuad + (chart.plotBox.width - xQuad) / 2, chart.plotBox.y, (chart.plotBox.width - xQuad) / 2, (chart.plotBox.height - yQuad) / 2, 1).attr({
          fill: quadFill3,
          zIndex: 0
        }).add();

        // "D" quad
        chart.renderer.rect(chart.plotBox.x, chart.plotBox.y + chart.plotBox.height - yQuad, xQuad, yQuad, 1).attr({
          fill: quadFill2,
          zIndex: 0
        }).add();

        // "C" quad
        chart.renderer.rect(chart.plotBox.x + xQuad, chart.plotBox.y + chart.plotBox.height - yQuad, chart.plotBox.width - xQuad, yQuad, 1).attr({
          fill: quadFill1,
          zIndex: 0
        }).add();
        var labelMargin = 5;
        var labelPadding = 7;
        var labelRadius = 3;
        var labelFill = wsColors.getRGBA(wsColors.wsBlack, 0.10);
        var labelColor = wsColors.wsBlack;
        var labelZIndex = 6;
        chart.renderer.label('A', chart.plotBox.x + xQuad + labelMargin, chart.plotBox.y + labelMargin).attr({
          fill: labelFill,
          color: labelColor,
          padding: labelPadding,
          r: labelRadius,
          zIndex: labelZIndex
        }).add();
        chart.renderer.label('A+', chart.plotBox.x + xQuad + (chart.plotBox.width - xQuad) / 2 + labelMargin, chart.plotBox.y + labelMargin).attr({
          fill: labelFill,
          color: labelColor,
          padding: labelPadding,
          r: labelRadius,
          zIndex: labelZIndex
        }).add();
        chart.renderer.label('B', chart.plotBox.x + labelMargin, chart.plotBox.y + labelMargin).attr({
          fill: labelFill,
          color: labelColor,
          padding: labelPadding,
          r: labelRadius,
          zIndex: labelZIndex
        }).add();
        chart.renderer.label('C', chart.plotBox.x + xQuad + labelMargin, chart.plotBox.y + chart.plotBox.height - yQuad + labelMargin).attr({
          fill: labelFill,
          color: labelColor,
          padding: labelPadding,
          r: labelRadius,
          zIndex: labelZIndex
        }).add();
        chart.renderer.label('D', chart.plotBox.x + labelMargin, chart.plotBox.y + chart.plotBox.height - yQuad + labelMargin).attr({
          fill: labelFill,
          color: labelColor,
          padding: labelPadding,
          r: labelRadius,
          zIndex: labelZIndex
        }).add();
      },
      getAxisFromMeasure: function getAxisFromMeasure(measure, dimension, config) {
        var dimensionLabel = typeof dimension === 'string' ? dimension : AggUtils.getDimensionInSentence(dimension, false);
        var axis = {
          tickPositioner: function tickPositioner() {
            var intervals = null;
            if (measure.valueProducer.statementProperty === 'result.score.scaled') {
              // use custom tick intervals for % based measures
              intervals = [1, 5, 10, 20, 50, 100];
            }
            var ext = this.getExtremes();
            return ChartUtils.tickPositioner(this.height, 40, measure.min ? measure.min.value : ext.dataMin, measure.max ? measure.max.value : ext.dataMax, intervals);
          },
          title: {
            text: measure.name + ' by ' + dimensionLabel
          },
          allowDecimals: config.displayAxisDecimals,
          startOnTick: true,
          endOnTick: true,
          showLastLabel: true,
          gridLineWidth: 1,
          labels: {
            formatter: null
          }
        };
        if (measure.valueProducer.statementProperty === 'result.score.scaled') {
          axis.labels.formatter = function () {
            return (this.value * 100).toFixed(0) + '%';
          };
        } else if (AggUtils.isDurationBasedMeasure(measure)) {
          axis.labels.formatter = function () {
            return (this.value < 0 ? '-' : '') + AggUtils.getMeasureValueDisplay({
              value: this.value
            }, measure);
          };
        } else {
          axis.labels.formatter = function () {
            return this.value;
          };
        }
        return axis;
      },
      _tooltipTemplate: null,
      getScatterPlotChart: function getScatterPlotChart(data, config, stats) {
        var removeHiddenMeasures = function removeHiddenMeasures(m, i) {
          return !config.hiddenMeasures || config.hiddenMeasures.indexOf(i) === -1;
        };
        var measures = config.measures.filter(removeHiddenMeasures);
        stats = stats.filter(removeHiddenMeasures);
        var dimensionLabels = AggUtils.getDimensionLabels({
          config: config,
          context: 'chart'
        });
        var xLabel = $sanitize(measures[0].name),
          yLabel = $sanitize(measures[1].name);
        var chart = {
          chart: {
            defaultSeriesType: 'scatter',
            borderWidth: 0,
            borderColor: '#ccc',
            backgroundColor: '#fff',
            plotBackgroundColor: '#fff',
            //user options for the quadrants, use benchmark or default to average value
            xQuadrant: measures[0].benchmark && measures[0].benchmark.value || stats[0] && stats[0].avg,
            yQuadrant: measures[1].benchmark && measures[1].benchmark.value || stats[1] && stats[1].avg
          },
          credits: {
            enabled: false
          },
          title: {
            text: null
          },
          legend: {
            enabled: true
          },
          info: {
            dimension: config.dimensions,
            measureFormatter: AggUtils.getMeasureValueDisplay,
            getDurationByUnit: this.getDurationByUnit,
            xValProd: measures[0],
            yValProd: measures[1]
          },
          tooltip: {
            headerFormat: '',
            _tooltipTemplate: this._tooltipTemplate,
            formatter: function formatter() {
              var tooltip = false;
              if (this.series.tooltipOptions.enabled) {
                var scope = {
                  name: this.point.name,
                  xName: xLabel,
                  yName: yLabel,
                  xValue: this.series.chart.userOptions.info.measureFormatter({
                    value: this.point.x
                  }, this.series.chart.userOptions.info.xValProd),
                  yValue: this.series.chart.userOptions.info.measureFormatter({
                    value: this.point.y
                  }, this.series.chart.userOptions.info.yValProd),
                  series: this.series,
                  point: this.point
                };
                tooltip = _.template(this.series.tooltipOptions._tooltipTemplate)(scope);
              }
              return tooltip;
            }
          },
          plotOptions: {
            series: {
              shadow: false
            },
            scatter: {
              marker: {
                symbol: 'circle',
                lineWidth: 1,
                lineColor: wsColors.wsGrayLight,
                states: {
                  hover: {
                    enabled: true,
                    lineWidth: 1,
                    lineColor: wsColors.wsGray
                  }
                }
              }
            }
          },
          xAxis: self.getAxisFromMeasure(measures[0], dimensionLabels[0], config),
          yAxis: self.getAxisFromMeasure(measures[1], dimensionLabels[0], config),
          series: [{
            name: $filter('capitalize')(dimensionLabels[0]),
            color: ChartUtils.getSeriesColor(config, 0, wsColors.getRGBA(wsColors.wsBlue, 0.5)),
            showInLegend: true,
            data: []
          }]
        };
        chart.series[0].data = _.chain(data).filter(function (d) {
          var aggs = d.aggregations.filter(removeHiddenMeasures);
          return !_.isUndefined(aggs[0].value) && !_.isUndefined(aggs[1].value);
        }).first(1000).map(function (d) {
          d.aggregations = d.aggregations.filter(removeHiddenMeasures);
          return {
            name: AggUtils.getDimensionDisplay(d.values[0], config.dimensions[0]),
            x: d.aggregations[0].value,
            xLabel: AggUtils.getMeasureValueDisplay(d.aggregations[0], config.measures[0]),
            y: d.aggregations[1].value,
            yLabel: AggUtils.getMeasureValueDisplay(d.aggregations[1], config.measures[1])
          };
        }).value();
        return chart;
      }
    };
    $templateRequest('modules/app/scatter-plot/scatterPlotTooltip.html').then(function (r) {
      self._tooltipTemplate = r;
    });
    return self;
  }]).
  // This is essentially initialization logic and for us it's primarily used here to append additional
  // routes for this specific card.
  config(['$routeProvider', function ($routeProvider) {
    // Add routes
    $routeProvider.when('/scatter/:cardId', {
      templateUrl: 'modules/app/scatter-plot/scatter-plot-detail.html',
      controller: id + ".Detail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/scatter/:cardId/top', {
      templateUrl: 'modules/app/scatter-plot/scatter-plot-card.html',
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    });
  }]).run(['CardIconMap', function (CardIconMap) {
    CardIconMap.register({
      "scatter": "scatter"
    });
  }]).controller(id + ".CardConfiguration", ["$scope", "$controller", function ($scope, $controller) {
    $scope.tempMeasures = scatterPlotMeasures;
    $scope.templateType = "scatter";
    $controller("AggregationCardConfiguration", {
      $scope: $scope
    });
    $scope.scatterPlotHelpText = {
      helpTitle: 'Scatter',
      detailText: 'The Scatter report displays learner performance on a scatter plot. Choose two measures, and Watershed displays individual or group performance of those measures on an X and Y axes. It’s ideal for identifying high and low performers on measures such as KPIs, competencies, or assessment scores.'
    };
    $scope.$watch("workingConfig.showQuadrants", _.debounce(function () {
      $scope.updateCardWithWorkingConfig();
    }, 100), true);

    // If we have more than 2 measures (i.e. coming from a different report)
    // remove extra measures since scatter plot can have 2 measures maximum.
    if ($scope.config && $scope.config.measures) {
      $scope.config.measures.splice($scope.config.hiddenMeasures ? $scope.config.hiddenMeasures.length + 2 : 2);
    }

    // Watch the measures, so the measureSelector can be disabled / enabled accordingly.
    $scope.$watch('measures', _.debounce(function (measures) {
      $scope.measureSelector.disabled = measures.length >= 2;
    }, 200), true);
  }]).controller(id + ".Card", ["$scope", "CardRegistry", id + '.Utils', 'AggregationUtils', 'wsEventNames', '$routeParams', 'ReportValidationService', function ($scope, CardRegistry, Utils, AggUtils, wsEvents, $routeParams, ReportValidationService) {
    // For use with /top route when embedding
    if (!$scope.cardId && $routeParams.cardId) {
      $scope.cardId = $routeParams.cardId;
    }
    $scope.config = CardRegistry.get($scope.cardId).configuration;

    // We don't want to sort scatter plot data
    $scope.config.defaultSort = undefined;
    $scope.defaultSummary = 'Scatter plot chart of measures organized by ' + AggUtils.getDimensionInSentence($scope.config.dimensions[0], true);
    var validation = ReportValidationService.validate($scope.cardId);
    if (validation.hasErrors) {
      $scope.hasData = false;
      $scope.noDataMsg = validation.message;
      return;
    }
    Utils.fetchData($scope.cardId || $scope.card.id, $scope.cardToPreview).then(function (r) {
      // Advertise that the preview loaded, with the preview data
      if ($scope.cardToPreview) {
        $scope.$emit(wsEvents.card.preview.loaded, r);
      }
      $scope.data = r.results[0].result.data;
      if (!Utils.ensureDataSize($scope, $scope.data)) {
        return;
      }
      $scope.stats = r.results[0].result.stats;
      $scope.scatterPlotChart = Utils.getScatterPlotChart($scope.data, $scope.config, $scope.stats);
      $scope.onHighChartComplete = Utils.onHighChartComplete;
      $scope.hasData = $scope.data.length > 0 && $scope.scatterPlotChart.series[0].data.length > 0;
    }, function () {
      $scope.hasData = false;
    });
  }]).controller(id + ".Detail", ["$scope", "$routeParams", id + ".Utils", "CardRegistry", 'ReportValidationService', 'Api', 'CardUtils', 'CardQueryResource', function ($scope, $routeParams, Utils, CardRegistry, ReportValidationService, Api, CardUtils, CardQueryResource) {
    $scope.cardId = $routeParams.cardId;
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;

    // We don't want to sort scatter plot data
    $scope.config.defaultSort = undefined;
    var validation = ReportValidationService.validate($scope.cardId);
    if (validation.hasErrors) {
      $scope.hasData = false;
      $scope.noDataMsg = validation.message;
      return;
    }
    var isPreview = $scope.cardId === 'preview',
      cardToPreview = isPreview ? $scope.card : null;
    Utils.fetchData($scope.cardId || $scope.card.id, cardToPreview).then(function (r) {
      $scope.data = r.results[0].result.data;
      if (!Utils.ensureDataSize($scope, $scope.data)) {
        return;
      }
      $scope.stats = r.results[0].result.stats;
      $scope.pagenote.setReportMetadata(r);
      $scope.scatterPlotChart = Utils.getScatterPlotChart($scope.data, $scope.config, $scope.stats);
      $scope.onHighChartComplete = Utils.onHighChartComplete;
      $scope.hasData = $scope.data.length > 0 && $scope.scatterPlotChart.series[0].data.length > 0;
    }, function () {
      $scope.hasData = false;
    });
    CardUtils.setNavElements($scope, $scope.cardId, $scope.cardId);
    $scope.subDetails = [{
      text: "Download data",
      downloadData: true,
      tooltip: "Download data tables",
      href: CardQueryResource.getDownloadUrl('scatter-plot/csv', $scope.cardId, $scope.config)
    }, {
      text: "Download interaction statements",
      downloadData: true,
      tooltip: "Download interaction statements",
      callback: Utils.getStatementDownloadUrl($scope.cardId === 'preview' ? $scope.config.filter : $scope.cardId)
    }];
    $scope.pagenote = {
      "clearCacheAction": "cards/" + $scope.cardId + "/cache"
    };
  }]);
})();
